import { Instance, SnapshotIn, types } from 'mobx-state-tree';

const OneCRate = types.model('OnboardingItem', {
	id: types.identifierNumber,
	name: types.optional(types.string, ''),
	service_id: types.number,
	onec_id: types.string,
});

export default OneCRate;

export interface IOneCRateModel extends Instance<typeof OneCRate> {}
export type IOneCRateSnapshotIn = SnapshotIn<typeof OneCRate>;
